var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workflow-management-container"},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view',{staticClass:"flex-grow-1 flex-scroll-height overflow-y-auto"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }